/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: tduzggWPyptPHtemkm2DXC
// Component: DjvhN87w1md0

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { BackToTop } from "@lg-plus/landing-components"; // plasmic-import: ZGEec7JbMDHq/codeComponent
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: tduzggWPyptPHtemkm2DXC/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: tduzggWPyptPHtemkm2DXC/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicBackToTopStyled.module.css"; // plasmic-import: DjvhN87w1md0/css

import ChevronDownIcon from "./icons/PlasmicIcon__ChevronDown"; // plasmic-import: N9NgtkGKC9Y5/icon

createPlasmicElementProxy;

export type PlasmicBackToTopStyled__VariantMembers = {};
export type PlasmicBackToTopStyled__VariantsArgs = {};
type VariantPropType = keyof PlasmicBackToTopStyled__VariantsArgs;
export const PlasmicBackToTopStyled__VariantProps =
  new Array<VariantPropType>();

export type PlasmicBackToTopStyled__ArgsType = {};
type ArgPropType = keyof PlasmicBackToTopStyled__ArgsType;
export const PlasmicBackToTopStyled__ArgProps = new Array<ArgPropType>();

export type PlasmicBackToTopStyled__OverridesType = {
  root?: Flex__<typeof BackToTop>;
  freeBox?: Flex__<"div">;
  svg?: Flex__<"svg">;
};

export interface DefaultBackToTopStyledProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicBackToTopStyled__RenderFunc(props: {
  variants: PlasmicBackToTopStyled__VariantsArgs;
  args: PlasmicBackToTopStyled__ArgsType;
  overrides: PlasmicBackToTopStyled__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <BackToTop
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "__wab_instance",
        "root_reset_tduzggWPyptPHtemkm2DXC",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootglobal_themeOrange_override]: hasVariant(
            globalVariants,
            "themeOrange",
            "override"
          )
        }
      )}
    >
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames("all", sty.freeBox, {
          [sty.freeBoxglobal_themeOrange_override]: hasVariant(
            globalVariants,
            "themeOrange",
            "override"
          )
        })}
      >
        <ChevronDownIcon
          data-plasmic-name={"svg"}
          data-plasmic-override={overrides.svg}
          className={classNames("all", sty.svg)}
          role={"img"}
        />
      </div>
    </BackToTop>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "freeBox", "svg"],
  freeBox: ["freeBox", "svg"],
  svg: ["svg"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: typeof BackToTop;
  freeBox: "div";
  svg: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicBackToTopStyled__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicBackToTopStyled__VariantsArgs;
    args?: PlasmicBackToTopStyled__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicBackToTopStyled__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicBackToTopStyled__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicBackToTopStyled__ArgProps,
          internalVariantPropNames: PlasmicBackToTopStyled__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicBackToTopStyled__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicBackToTopStyled";
  } else {
    func.displayName = `PlasmicBackToTopStyled.${nodeName}`;
  }
  return func;
}

export const PlasmicBackToTopStyled = Object.assign(
  // Top-level PlasmicBackToTopStyled renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    svg: makeNodeComponent("svg"),

    // Metadata about props expected for PlasmicBackToTopStyled
    internalVariantProps: PlasmicBackToTopStyled__VariantProps,
    internalArgProps: PlasmicBackToTopStyled__ArgProps
  }
);

export default PlasmicBackToTopStyled;
/* prettier-ignore-end */
